import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { CircularProgress, LinearProgress, Paper, Typography } from '@mui/material';

import { useSettings, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface DetailsSectionShippingChargesProps {
	orderUid: string;
	country?: string;
	orderTotValueTaxExcl?: number;
}

export default function DetailsSectionShippingCharges(props: DetailsSectionShippingChargesProps) {
	const { t } = useSettings();
	const dispatch = useDispatch();

	const [shippingCharges, setShippingCharges] = React.useState<any>({});
	const [isLoading, setIsLoading] = React.useState(false);

	React.useEffect(() => {
		setIsLoading(true);

		Utils.executeStored({
			action: 'st_orders_shippingcharges_list_active',
			params: { ords_uid: props.orderUid },
			dispatch,
			successHandler: response => {
				setShippingCharges(response.data || []);
				setIsLoading(false);
			}
		});
	}, [dispatch, props.orderUid]);

	const progress = ((props.orderTotValueTaxExcl || 0) * 100) / shippingCharges.free?.shch_tot_value_from;
	const isReached =
		!shippingCharges.free?.shch_tot_value_from ||
		shippingCharges.free?.shch_tot_value_from <= (props.orderTotValueTaxExcl || 0);
	const isUnderMax =
		!shippingCharges.free?.shch_tot_value_to ||
		shippingCharges.free?.shch_tot_value_to > (props.orderTotValueTaxExcl || 0);

	if (isLoading)
		return (
			<Paper className="rounded-8 p-16 text-center" variant="outlined">
				<CircularProgress variant="indeterminate" disableShrink />
			</Paper>
		);

	return (
		<DetailsSectionWrapper
			title={
				<FormattedMessage
					id="ordersDetailsSectionShippingCharges.title"
					defaultMessage={t('ORDERS_SHIPPINGCHARGES_SECTION_TITLE')}
					values={{
						value: shippingCharges.current?.shch_value ? (
							<FormattedNumber
								value={shippingCharges.current?.shch_value}
								style="currency"
								currency="EUR"
							/>
						) : (
							'--'
						)
					}}
				/>
			}
			subheader={
				<FormattedMessage
					id="ordersDetailsSectionShippingCharges.subheader"
					defaultMessage={t('ORDERS_SHIPPINGCHARGES_SECTION_SUBTITLE')}
					values={{ country: props.country }}
				/>
			}
		>
			{!!shippingCharges.free && !isReached && (
				<>
					<Typography className="px-8 text-end" variant="subtitle2">
						<FormattedMessage
							id="ordersDetailsSectionShippingCharges.progress"
							defaultMessage={t('ORDERS_SHIPPINGCHARGES_SECTION_PROGRESS')}
							values={{
								value: (
									<FormattedNumber
										value={
											shippingCharges.free.shch_tot_value_from - (props.orderTotValueTaxExcl || 0)
										}
										style="currency"
										currency="EUR"
									/>
								)
							}}
						/>
					</Typography>
					<LinearProgress
						variant="determinate"
						color={isReached && isUnderMax ? 'success' : 'inherit'}
						value={progress > 100 ? 100 : progress}
					/>
				</>
			)}
		</DetailsSectionWrapper>
	);
}
